import Users from '@/services/api/sys-users'
import ProcessItemsApi from '@/services/api/bl-processitems'
import JurisprudenceFilesApi from '@/services/api/bl-jurisprudencefiles'

// Forms
import Forms from '@/components/forms'

// Components
import Datatable from '@/components/ui/Datatable'
import ActivateUserElement from '@/components/ui/DatatableElements/ActivateUserElement'
import DeleteElement from '@/components/ui/DatatableElements/DeleteElement'
import EditElement from '@/components/ui/DatatableElements/EditElement'
import OrderElement from '@/components/ui/DatatableElements/OrderElement'
import ToggleOptionElement from '@/components/ui/DatatableElements/ToggleOptionElement'
import Mailbox from '@/components/ui/Mailbox'
import Sortable from '@/components/ui/Sortable'
import ExportAccountsButton from '@/components/forms/Bl/ExportAccountsButton'

import ProcessItemCard from '@/components/forms/Bl/ProcessItemCard'
import JurisprudenceCategoryCard from '@/components/forms/Bl/JurisprudenceCategoryCard'

export const blAuthorizations = {
  url: '/bl/authorizations',
  datatable: false
}

export const blBankAccounts = {
  add: false,
  nested: true,
  parent: 'sys-users',
  parentKey: 'user_id',
  name: 'Contas Bancárias',
  form: Forms.Bl.BankAccount,
  url: '/bl/bank-accounts',
  key: 'bl-bankaccounts',
  indexComponent: false,
  tableOptions: {
    with: ['process'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;',
        props: {
          labels: ['Visível', 'Oculto'],
          classes: ['fa fa-eye', 'fa fa-eye-slash'],
          colors: ['green', 'gray']
        }
      },
      {
        label: 'Processo',
        key: 'process.company_name',
        sortable: false
      },
      {
        label: 'Banco',
        key: 'bank',
        sortable: true
      },
      {
        label: 'Favorecido',
        key: 'favored_name',
        sortable: true
      }
    ]
  }
}

export const sysUsers = {
  name: 'Usuários',
  key: 'sys-users',
  url: '/system/users',
  api: Users,
  form: Forms.System.User,
  formOptions: {
    api: {
      params: {
        with: ['address.city', 'bankAccounts.file']
      }
    },
    'omit': [ 'address.city', 'first_name', 'last_name' ]
  },
  indexComponent: Datatable,
  sort: 'id:desc',
  tableOptions: {
    with: ['authorization'],
    fields: [
      {
        label: '',
        key: 'authorization.completed',
        component: ToggleOptionElement,
        props: {
          disabled: true,
          classes: [
            'fa fa-check-circle-o',
            'fa fa-times-circle-o'
          ]
        },
        style: 'width: 30px;'
      },
      {
        align: 'left', // defaults to left
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      },
      {
        label: 'Perfil',
        key: 'main_role.name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Nome',
        key: 'name',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Email',
        key: 'email',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Documento',
        key: 'document',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      }
    ],
    actions: [
      { component: ActivateUserElement },
      { component: EditElement },
      { component: DeleteElement }
    ]
  }
}

export const processItems = {
  name: 'Itens dos Processos',
  api: ProcessItemsApi,
  url: '/bl/process-items',
  key: 'bl-process-items',
  form: Forms.Bl.ProcessItem,
  formOptions: {
    api: {
      params: {
        with: ['media', 'file']
      }
    },
    omit: ['file']
  },
  indexComponent: Datatable,
  tableOptions: {
    with: ['process', 'category'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        align: 'left', // defaults to left
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      },
      {

        label: 'Processo',
        key: 'process.company_name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {

        label: 'Categoria',
        key: 'category.name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Nome',
        key: 'name',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      }

    ]
  },
  sortableComponent: ProcessItemCard,
  options: {
    with: ['file', 'media']
  }
}

export const processItemsJurisprudence = {
  name: 'Arquivos Jurisprudência',
  url: '/bl/jurisprudence-files',
  key: 'bl-jurisprudence-files',
  api: JurisprudenceFilesApi,
  form: Forms.Bl.JurisprudenceFile,
  formOptions: {
    api: {
      params: {
        with: ['media', 'file']
      }
    },
    omit: ['file']
  },
  indexComponent: Datatable,
  tableOptions: {
    with: ['category'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        align: 'left', // defaults to left
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      },
      // {
      //
      //   label: 'Processo',
      //   key: 'process.company_name',
      //   // sortable: true,
      //   // style: '',
      //   class: 'text-ellipsis'
      // },
      {

        label: 'Categoria',
        key: 'category.name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Nome',
        key: 'name',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      }

    ]
  },
  sortableComponent: JurisprudenceCategoryCard,
  options: {
    with: ['file', 'media']
  }
}

export const blProcessCategories = {
  name: 'Categorias de Processos',
  form: Forms.Bl.ProcessCategory,
  url: '/bl/process-categories',
  key: 'bl-process-categories',
  indexComponent: Datatable,
  tableOptions: {
    with: ['process'],
    fields: [
      {
        label: '',
        key: 'status',
        component: ToggleOptionElement,
        style: 'width: 30px;'
      },
      {
        align: 'left', // defaults to left
        label: '#',
        key: 'id',
        sortable: true,
        style: 'width: 80px;'
      },
      {
        label: 'Nome',
        key: 'name',
        sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      {
        label: 'Processo',
        key: 'process.company_name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      },
      // {
      //   label: 'Slug',
      //   key: 'slug',
      //   sortable: true,
      //   // style: '',
      //   class: 'text-ellipsis'
      // },
      {
        label: 'Tipo',
        // key: 'type',
        key: 'type_name',
        // sortable: true,
        // style: '',
        class: 'text-ellipsis'
      }
    ]
  },
  options: {
    scopes: ['ordered'],
    component: Forms.Bl.ProcessCategoryCard,
    name: 'Categorias'
  }
}

export default {
  /**
   * General Entities
   */
  'bl-bankaccounts': blBankAccounts,
  // BANNERS
  'bl-banners': {
    name: 'Banners',
    form: Forms.Bl.Banner,
    url: '/bl/banners',
    key: 'bl-banners',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.BannerCard,
      name: 'Banners'
    }
  },

  // FAQ
  'bl-questions': {
    name: 'Dúvidas Frequentes',
    form: Forms.Bl.Question,
    url: '/bl/questions',
    key: 'bl-questions',
    order: '/#/bl-questions-order/',
    indexComponent: Datatable,
    tableOptions: {
      export: ['id', 'query', 'answer'],
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Pergunta',
          key: 'query',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Resposta',
          key: 'answer',
          sortable: true
        }
      ]
    }
  },
  // FAQ ORDER
  'bl-questions-order': {
    name: 'Ordernar as Dúvidas Frequentes',
    form: Forms.Bl.Question,
    url: '/bl/questions',
    key: 'bl-questions',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.QuestionCard,
      name: 'Dúvidas Frequentes'
    }
  },
  // CONTACTS
  'bl-contacts': {
    name: 'Contatos',
    url: '/bl/contacts',
    key: 'bl-contacts',
    indexComponent: Mailbox,
    indexOptions: {
      omit: ['attachments'],
      with: ['attachments.file'],
      orderBy: 'created_at:desc',
      multipleAttachments: true,
      read: 'status'
    },
    filters: [
      {
        label: 'Lidos',
        icon: 'fa fa-envelope-open-o',
        params: ['status:1']
      },
      {
        label: 'Não lidos',
        icon: 'fa fa-envelope',
        params: ['status:0']
      }
    ]
  },

  // CAREER-CONTACTS
  'bl-career-contacts': {
    name: 'Trabalhe Conosco',
    url: '/bl/career-contacts',
    key: 'bl-career-contacts',
    indexComponent: Mailbox,
    indexOptions: {
      omit: ['file'],
      with: ['file'],
      orderBy: 'created_at:desc',
      read: 'status',
      attachments: 'file',
      multipleAttachments: false,
      subject: 'career',
      body: 'presentation'
    },
    filters: false
  },

  /**
   * BL Content
   */

  // Story List
  'bl-stories': {
    name: 'Notícias',
    url: '/bl/stories',
    key: 'bl-stories',
    form: Forms.Bl.Story,
    formOptions: {
      api: {
        params: {
          with: ['media', 'seo', 'friendlyUrls']
        }
      }
    },
    indexComponent: Datatable,
    tableOptions: {
      // export: ['id', 'highlight', 'title', 'release_date'],
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          label: '',
          key: 'highlight',
          component: ToggleOptionElement,
          props: {
            labels: ['Destaque', 'Regular'],
            classes: ['fa fa-star', 'fa fa-star-o'],
            colors: ['#d39e00', 'gray']
          },
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Titulo',
          key: 'title',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Publicação',
          key: 'release_date',
          sortable: true,
          formatters: [
            {
              type: 'date',
              args: 'DD/MM/YYYY'
            }
          ],
          // style: '',
          class: 'text-ellipsis'
        }

      ]
    }
  },

  // Story Categories
  'bl-story-categories': {
    name: 'Categoria de Notícias',
    url: '/bl/story-categories',
    key: 'bl-story-categories',
    order: '/#/bl-story-categories-order/',
    form: Forms.Bl.StoryCategory,
    indexComponent: Datatable,
    tableOptions: {
      // export: ['id', 'highlight', 'name', 'slug'],
      // orderBy: {
      //   name: 'name',
      //   direction: 'asc'
      // },
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          label: '',
          key: 'highlight',
          component: ToggleOptionElement,
          props: {
            labels: ['Destaque', 'Regular'],
            classes: ['fa fa-star', 'fa fa-star-o'],
            colors: ['#d39e00', 'gray']
          },
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'name',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        }
      ]
    }
  },

  // Story Categories ORDER
  'bl-story-categories-order': {
    name: 'Ordernar as Categoria de Notícias',
    form: Forms.Bl.StoryCategory,
    url: '/bl/story-categories',
    key: 'bl-story-categories',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.StoryCategoryCard,
      name: 'Categoria de Notícias'
    }
  },

  // Process File Types
  'bl-process-file-types': {
    name: 'Tipos de Processos',
    form: Forms.Bl.ProcessFileType,
    url: '/bl/process-file-types',
    key: 'bl-process-file-types',
    // with: 'role',
    indexComponent: Datatable,
    tableOptions: {
      with: ['role'],
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'name',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Perfil',
          key: 'role.name',
          // sortable: true,
          // style: '',
          class: 'text-ellipsis'
        }
      ]
    }
  },

  // Process Categories
  'bl-process-categories': blProcessCategories,

  // Process
  'bl-processes': {
    name: 'Processos',
    form: Forms.Bl.Process,
    formOptions: {
      api: {
        params: {
          with: ['media', 'submissions.attachments.file', 'submissions.user', 'submissions.type', 'followers']
        }
      }
    },
    url: '/bl/processes',
    key: 'bl-processes',
    // order: '/#/bl-processes-order/',
    indexComponent: Datatable,
    indexButtons: [
      ExportAccountsButton
    ],
    tableOptions: {
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'company_name',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        }
      ]
    }
  },

  // Process Types ORDER
  'bl-processes-order': {
    name: 'Ordernar os Processos',
    form: Forms.Bl.Process,
    url: '/bl/processes',
    key: 'bl-processes',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.ProcessCard,
      name: 'Processos'
    }
  },

  // Process Itens
  'bl-process-items': processItems,

  // Process Itens
  'bl-jurisprudence-files': processItemsJurisprudence,

  // Process Types
  'bl-process-types': {
    name: 'Tipos de processo',
    url: '/bl/process-types',
    // api: Users,
    key: 'bl-process-types',
    order: '/#/bl-process-types-order/',
    form: Forms.Bl.ProcessType,
    formOptions: {
      api: {
        params: {
          with: []
        }
      },
      'omit': [ 'created_at', 'updated_at' ]
    },
    indexComponent: Datatable,
    sort: 'id:desc',
    tableOptions: {
      with: [],
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left',
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'name',
          sortable: true,
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          class: 'text-ellipsis'
        }
      ],
      actions: [
        { component: OrderElement },
        { component: EditElement },
        { component: DeleteElement }
      ]
    }
  },

  // Process Types ORDER
  'bl-process-types-order': {
    name: 'Ordernar os Tipos de Processos',
    form: Forms.Bl.ProcessType,
    url: '/bl/process-types',
    key: 'bl-process-types',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.ProcessTypeCard,
      name: 'Tipos de Processos'
    }
  },

  // Jurisprudence Categories
  'bl-jurisprudence-categories': {
    name: 'Categorias de Jurisprudência',
    url: '/bl/jurisprudence-categories',
    key: 'bl-jurisprudence-categories',
    order: '/#/bl-jurisprudence-categories-order/',
    form: Forms.Bl.JurisprudenceCategory,
    indexComponent: Datatable,
    tableOptions: {
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'name',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        }
      ]
    }
  },

  // Jurisprudence ORDER
  'bl-jurisprudence-categories-order': {
    name: 'Ordernar as Categorias de Jurisprudência',
    form: Forms.Bl.JurisprudenceCategory,
    url: '/bl/jurisprudence-categories',
    key: 'bl-jurisprudence-categories',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.JurisprudenceCategoryCard,
      name: 'Categorias de Jurisprudência'
    }
  },

  // Jurisprudence Files
  // 'bl-jurisprudence-files': {
  //   name: 'Arquivos de Jurisprudência',
  //   url: '/bl/jurisprudence-files',
  //   key: 'bl-jurisprudence-files',
  //   form: Forms.Bl.JurisprudenceFile,
  //   formOptions: {
  //     omit: ['file']
  //   },
  //   indexComponent: Datatable,
  //   tableOptions: {
  //     with: ['category'],
  //     fields: [
  //       {
  //         label: '',
  //         key: 'status',
  //         component: ToggleOptionElement,
  //         style: 'width: 30px;'
  //       },
  //       {
  //         align: 'left', // defaults to left
  //         label: '#',
  //         key: 'id',
  //         sortable: true,
  //         style: 'width: 80px;'
  //       },
  //       {
  //         label: 'Categoria',
  //         key: 'category.name',
  //         // sortable: true,
  //         // style: '',
  //         class: 'text-ellipsis'
  //       },
  //       {
  //         label: 'Nome',
  //         key: 'name',
  //         sortable: true,
  //         // style: '',
  //         class: 'text-ellipsis'
  //       },
  //       {
  //         label: 'Criado em',
  //         key: 'created_at',
  //         sortable: true,
  //         formatters: [
  //           {
  //             type: 'date',
  //             args: 'DD/MM/YYYY'
  //           }
  //         ],
  //         // style: '',
  //         class: 'text-ellipsis'
  //       }
  //     ]
  //   }
  // },

  // Resumes
  'bl-resumes': {
    name: 'Currículos',
    url: '/bl/resumes',
    key: 'bl-resumes',
    order: '/#/bl-resumes-order/',
    form: Forms.Bl.Resume,
    indexComponent: Datatable,
    tableOptions: {
      fields: [
        {
          label: '',
          key: 'status',
          component: ToggleOptionElement,
          style: 'width: 30px;'
        },
        {
          align: 'left', // defaults to left
          label: '#',
          key: 'id',
          sortable: true,
          style: 'width: 80px;'
        },
        {
          label: 'Nome',
          key: 'name',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        },
        {
          label: 'Slug',
          key: 'slug',
          sortable: true,
          // style: '',
          class: 'text-ellipsis'
        }
      ]
    }
  },

  // Resume ORDER
  'bl-resumes-order': {
    name: 'Ordernar os Currículos',
    form: Forms.Bl.Resume,
    url: '/bl/resumes',
    key: 'bl-resumes',
    indexComponent: Sortable,
    options: {
      component: Forms.Bl.ResumeCard,
      name: 'Currículos'
    }
  },

  // USERS
  'sys-users': sysUsers,

  'bl-authorizations': blAuthorizations
}



// WEBPACK FOOTER //
// ./src/_entities.js